var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainContent',[_c('template',{slot:"tl-container"},[_c('div',{staticClass:"tl_content h-100 gradient text-white p-3"},[_c('home',{staticClass:"h-100 w-100 d-flex flex-column p-3",attrs:{"id":"Home"}})],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }